<template>
  <div class="cn-mappings-versions">
    <div class="mappings">
      <button
        class="button-clear"
        :disabled="selectedMappingElements.length == 0"
        @click="resetMapping"
      >
        Clear
      </button>
      <div v-for="mapping in mappings" :key="mapping.id" class="mapping">
        <div class="checkbox-container">
          <input
            type="checkbox"
            :id="prependInstanceId(mapping.id)"
            :checked="mappingIsChecked(mapping)"
            @change="setSelectedMapping(mapping, $event)"
          />
          <label class="c-checkbox" :for="prependInstanceId(mapping.id)">
            {{ mapping.title?.value }}
          </label>
          <span class="openModal" @click="showModal(mapping.id)">See details</span>
        </div>

        <VueFinalModal
          :modalId="mapping.id"
          class="final-modal fullwidthModal controls-navigator"
          content-class="final-modal-content"
          content-transition="vfm-fade"
          overlay-transition="vfm-fade"
        >
          <div class="c-modal">
            <div class="c-modal__content">
              <button class="c-modal__close" @click="hideModal(mapping.id)">X</button>
              <h3>{{ mapping.title?.value }}</h3>
              <div class="c-modal-container">
                <div class="c-modal__list">
                  <div
                    class="item"
                    v-for="(mappingElement, index) in mapping.mappingElements"
                    :key="mappingElement.id"
                  >
                    <div class="checkbox-container">
                      <input
                        type="checkbox"
                        :checked="mappingElementIsChecked(mappingElement)"
                        :id="prependInstanceId(mappingElement.id)"
                        @change="setSelectedMappingElement(mappingElement, $event)"
                      />
                      <label class="c-checkbox" :for="prependInstanceId(mappingElement.id)">
                        {{ mappingElement.code?.value }}
                      </label>

                      <div class="description" :class="{ open: isOpen.includes(index) }">
                        <div class="description__short">
                          {{
                            getDescription(
                              mappingElement.title?.value,
                              mappingElement.description?.value,
                              true
                            )
                          }}&nbsp;&nbsp;
                          <span
                            class="toggle close"
                            v-if="
                              getDescription(
                                mappingElement.title?.value,
                                mappingElement.description?.value,
                                false
                              ).length > 34
                            "
                            @click="showMore(index)"
                          ></span>
                        </div>
                        <div class="description__long">
                          {{
                            getDescription(
                              mappingElement.title?.value,
                              mappingElement.description?.value,
                              false
                            )
                          }}&nbsp;&nbsp;
                          <span class="toggle open" @click="showLess(index)"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VueFinalModal>
      </div>
    </div>
    <div class="mappings-buttons">
      <button
        class="button-reset"
        :disabled="selectedMappingElements.length == 0"
        @click="resetMapping"
      >
        Reset Selections
      </button>
      <button class="button-collapse" @click="closeMapping">Collapse</button>
    </div>
  </div>
</template>

<script>
import { VueFinalModal, useVfm } from 'vue-final-modal';
import { v4 as uuidv4 } from 'uuid';

import 'vue-final-modal/style.css';

export default {
  name: 'CIS-Controls-Navigator-Mappings',
  components: {
    VueFinalModal
  },
  props: {
    mappings: {
      type: Array,
      default: () => []
    },
    selectedMappingElements: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: []
    };
  },
  emits: ['setSelectedMappingElement', 'toggleMapping'],
  setup(props) {
    const vfm = useVfm();

    return {
      vfm
    };
  },
  beforeCreate() {
    this.instanceId = uuidv4().replaceAll('-', '');
  },
  methods: {
    prependInstanceId(id) {
      return `${this.instanceId}_${id}`;
    },
    mappingIsChecked(mapping) {
      const output = mapping.mappingElements.some((me) =>
        this.selectedMappingElements.some((s) => s === me.id)
      );
      return output;
    },
    mappingElementIsChecked(mappingElement) {
      const output = this.selectedMappingElements.includes(mappingElement.id);
      return output;
    },
    setSelectedMapping(mapping, event) {
      event.preventDefault();

      // If the Mapping already has some child Mapping Elements selected, then remove all
      // child Mapping Elements.
      const removeElements = mapping.mappingElements.some((me) => this.mappingElementIsChecked(me));

      // Send array of Mapping Elements to the setSelectedMappingElement function
      // so it does't call to refresh the DOM for each one.
      const ids = mapping.mappingElements
        .filter((me) => !removeElements || this.selectedMappingElements.includes(me.id))
        .map((me) => me.id);

      this.$emit('setSelectedMappingElement', ids, removeElements);
    },
    setSelectedMappingElement(mappingElement, event) {
      event.preventDefault();

      const removeId =
        this.selectedMappingElements && this.selectedMappingElements.includes(mappingElement.id);
      this.$emit('setSelectedMappingElement', mappingElement.id, removeId);
    },
    resetMapping() {
      this.$emit('setSelectedMappingElement', null, true);
    },
    closeMapping() {
      this.$emit('toggleMapping');
    },
    getShort(name) {
      const maxLength = 34;

      //trim the string to the maximum length
      if (name.length > maxLength) {
        var trimmedString = name.substr(0, maxLength);

        //re-trim if we are in the middle of a word
        return (trimmedString = trimmedString.substr(
          0,
          Math.min(trimmedString.length, trimmedString.lastIndexOf(' '))
        ));
      } else {
        return name;
      }
    },
    getDescription(title, description, option) {
      var item = '';
      if (title.length != 0 && description.length != 0) {
        item = title;
      } else if (title.length != 0) {
        item = title;
      } else if (description.length != 0) {
        item = description;
      }

      if (option) {
        return this.getShort(item);
      } else {
        return item;
      }
    },
    showModal(name) {
      this.vfm.open(name);
    },
    hideModal(name) {
      this.vfm.close(name);
      this.isOpen = [];
    },
    showMore(index) {
      this.isOpen.push(index);
    },
    showLess(index) {
      this.isOpen = this.isOpen.filter((i) => i !== index);
    }
  }
};
</script>
<style scoped lang="scss">
@import '~@/assets/scss/components/checkbox.scss';

.cn-mappings-versions {
  position: relative;
  .button-clear {
    position: absolute;
    top: 3.2rem;
    right: 2rem;
    background: transparent;
    border: none;
    @include font-styles('Arial', 1.6rem, 600, normal, 2rem, 0, $gray);

    @include tablet-up {
      display: none;
    }

    &:disabled {
      opacity: 0.5;
    }
  }
  .mappings {
    padding: 6.7rem 2rem 0 2rem;
    border-bottom: solid 0.1rem $divider;

    @include tablet-up {
      display: flex;
      flex-wrap: wrap;
      padding: 3rem 2rem 2rem 4rem;
    }

    &-buttons {
      padding: 2rem 3.5rem 2rem 1rem;

      @include tablet-up {
        padding: 2.5rem 4rem;
      }
    }

    .mapping {
      margin-bottom: 2.4rem;

      @include tablet-up {
        width: calc(100% / 3);
        padding-right: 2rem;
        margin-bottom: 2rem;
      }

      & label {
        cursor: pointer;
        @include font-styles('Arial', 1.6rem, 300, normal, 2.4rem, 0, $gray);
      }

      & span {
        cursor: pointer;
        display: inline-block;
        @include font-styles('Arial', 1.6rem, 500, normal, 2.4rem, 0, $blue);
      }

      [type='checkbox']:not(:checked) + label:before {
        background-color: $white;

        @include tablet-up {
          background-color: $box-gray;
        }
      }

      .c-checkbox {
        display: initial;
        max-width: none;
        position: initial;
        margin-right: 0.5rem;
      }
    }
  }

  .mappings-buttons {
    display: flex;
    justify-content: space-between;

    button {
      background: transparent;
      border: none;
      text-transform: uppercase;
      @include font-styles('Arial Narrow', 1.8rem, 600, normal, 2.2rem, 0, $blue);

      &.button-reset {
        position: relative;
        padding-right: 2rem;

        &:after {
          content: '';
          position: absolute;
          top: 0.5rem;
          right: 0;
          background-image: url(~@/assets/images/icon-reset-blue.svg);
          background-repeat: no-repeat;
          background-size: contain;
          width: 1.5rem;
          height: 1.5rem;
        }
      }

      &:disabled {
        color: rgba(48, 62, 72, 0.5);

        &.button-reset {
          &:after {
            content: '';
            background-image: url(~@/assets/images/icon-reset-grey.svg);
            background-repeat: no-repeat;
            background-size: contain;
            opacity: 0.5;
          }
        }
      }

      &.button-collapse {
        position: relative;

        &:before {
          position: absolute;
          top: 50%;
          right: 0;
          pointer-events: none;
          content: '';
          border: solid $blue;
          border-width: 0 0.2rem 0.2rem 0;
          display: inline-block;
          padding: 0.5rem;
          margin-right: -2.2rem;
          transform: translate(-50%, -23%) rotate(-135deg);
        }
      }
    }
  }
}
</style>
